import { useTranslation } from 'react-i18next';
import ReactJson from 'react-json-view';
import { useNavigate, useParams } from 'react-router-dom';

import {
  Card,
  DataError,
  LoadingIndicator,
  Typography
} from '@destination/components';

import useModelDetails from '@/api/use-model-details';

export default function ModelDetails() {
  const { aggregateId } = useParams() as { aggregateId: string };
  const navigate = useNavigate();

  const { t } = useTranslation(undefined, { keyPrefix: 'model_details' });

  const { model, isLoading, isError } = useModelDetails(aggregateId);

  return (
    <>
      <section className="mt-4">
        <Typography variant="sectionTitle">
          {t('json_representation')}
        </Typography>
        <Card data-testid="json-view-wrapper" className="mt-2">
          {isLoading && <LoadingIndicator>{t('loading')}</LoadingIndicator>}
          {isError && (
            <DataError variant="primary" onRefresh={() => navigate(0)} />
          )}
          {model && (
            <ReactJson
              data-testid="json-view"
              name={null}
              quotesOnKeys={false}
              displayDataTypes={false}
              displayObjectSize={false}
              src={JSON.parse(model.content)}
            />
          )}
        </Card>
      </section>
    </>
  );
}
